import { keyframes, css } from "styled-components"

export const FadeIn = keyframes`
 {
  0% {
    opacity: 0.05;
  }
  100% {
    opacity: 1;
  }
}`

export const FadeInBottom = keyframes`
 {
  0% {
    transform: translateY(60px);
    opacity: 0.05;
  }
  100% {
    transform: translateY(0);
    opacity: 1;
  }
}
`

export const CSSAnimation = animation => {
  return css`
    animation: ${props => !props.disableAnimations && animation};
    animation-play-state: ${props => (props.isVisible ? "running" : "paused")};
    animation-duration: ${props => props.duration ?? "1s"};
    animation-timing-function: ${props => props.timingFunction ?? "ease"};
    animation-delay: ${props => props.delay ?? "0s"};
    animation-fill-mode: ${props => props.fillMode ?? "both"};
  `
}
